var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloverLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.875 20.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.737 4.908c0-2-1.2-3.7-3-4.5-1.8-.8-3.9-.4-5.3 1s-1.8 3.5-1.1 5.3c.7 1.8 2.5 3 4.5 3h4.9zm1.4 0c0-2 1.2-3.7 3-4.5 1.8-.8 3.9-.4 5.3 1s1.8 3.5 1.1 5.3-2.5 3-4.5 3h-4.9zm0 11c0 2 1.2 3.7 3 4.5s3.9.4 5.3-1 1.8-3.5 1.1-5.3-2.5-3-4.5-3h-4.9zm-6.3 3.5c1.9 0 3.5-1.5 3.5-3.5v-3.5h-3.5c-1.9 0-3.5 1.5-3.5 3.5s1.6 3.5 3.5 3.5zm4.9-3.5c0 2-1.2 3.7-3 4.5s-3.9.4-5.3-1-1.8-3.5-1.1-5.3c.7-1.8 2.5-3 4.5-3h4.9z",
    fill: "#280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloverLogo);
export default __webpack_public_path__ + "static/media/CloverLogo.921a8b55274ee30e3cc32f3ccef80df0.svg";
export { ForwardRef as ReactComponent };